import type {ReactNode} from 'react'
import {RenderIf} from 'components'

export type AlertBannerTextProps = {
  prefixLabel?: ReactNode
  message: ReactNode
  trailing?: ReactNode
}

export const AlertBannerText = ({
  prefixLabel,
  message,
  trailing,
}: AlertBannerTextProps): JSX.Element => {
  return (
    <p className="karla text-sm text-white">
      <RenderIf isTrue={Boolean(prefixLabel)}>
        <span className="karla-bold text-red-100">{`${prefixLabel} `}</span>
      </RenderIf>
      {message}
      {trailing}
    </p>
  )
}
